import React from 'react';
import LockedSectionPage from '@/components/course/LockedSectionPage';
import PageTitle from '@/components/PageTitle';
import ThemeWrapper from '@/components/ThemeWrapper';
import AppLayout from '@/layouts/AppLayout';
import { SectionData } from '@/types';

interface CourseData {
    slug: string;
    title: string;
}

type Props = {
    course: CourseData;
    section: SectionData;
};

const LockedSectionContent: React.FC<Props> = ({ course, section }) => {
    const pageTitle = `${section.title} - Bloqueado`;

    return (
        <AppLayout>
            <PageTitle title={pageTitle} />
            <LockedSectionPage
                section={section}
                courseSlug={course.slug}
                courseTitle={course.title}
            />
        </AppLayout>
    );
};

const LockedSection: React.FC<Props> = ({ course, section }) => {
    return (
        <ThemeWrapper>
            <LockedSectionContent course={course} section={section} />
        </ThemeWrapper>
    );
};

export default LockedSection;